import { getPossibleMoves } from '../utils/movement';
import { getPossibleWalls } from '../utils/walls';

export const makeRandomMove = ({
  turnAction,
  board,
  currentPlayer,
  walls,
  separatedCellsGroups,
  selectedStone,
  handleCellClick,
  handleWallClick
}) => {
  if (turnAction === 'place') {
    // Find empty cell
    const emptyCells = [];
    for (let i = 0; i < board.length; i++) {
      for (let j = 0; j < board.length; j++) {
        if (!board[i][j]) {
          emptyCells.push({ row: i, col: j });
        }
      }
    }
    if (emptyCells.length > 0) {
      const randomCell = emptyCells[Math.floor(Math.random() * emptyCells.length)];
      handleCellClick(randomCell.row, randomCell.col, true);
    }
  } else if (turnAction === 'move' && selectedStone) {
    const validMoves = getPossibleMoves(board, walls, selectedStone.row, selectedStone.col);
    const randomMove = validMoves[Math.floor(Math.random() * validMoves.length)];
    handleCellClick(randomMove.row, randomMove.col, true);
  } else if (turnAction === 'move') {
    // Get all stones of current player
    const playerStones = [];
    for (let i = 0; i < board.length; i++) {
      for (let j = 0; j < board.length; j++) {
        if (board[i][j] === currentPlayer) {
          playerStones.push({ row: i, col: j });
        }
      }
    }

    const settledStones = []

    // Try stones until we find one that can move
    while (playerStones.length > 0) {
      const randomIndex = Math.floor(Math.random() * playerStones.length);
      const stone = playerStones[randomIndex];

      // Check if stone is in a settled group
      const group = separatedCellsGroups?.find(group =>
        group.cells.some(cell => cell.row === stone.row && cell.col === stone.col)
      );

      if (group?.settled) {
        // Remove settled stone from consideration
        settledStones.push(stone);
        playerStones.splice(randomIndex, 1);
        continue;
      }

      // Find valid moves for the selected stone
      const validMoves = getPossibleMoves(board, walls, stone.row, stone.col);

      // Remove stone without valid moves from consideration
      if (validMoves.length === 0) {
        playerStones.splice(randomIndex, 1);
        continue;
      }

      // Found a stone with valid moves
      handleCellClick(stone.row, stone.col, true);
      return;
    }

    // At this point looks like there's no valid move within unsettled groups.
    // We're forced to move a settled stone.
    for (const stone of settledStones) {
      const validMoves = getPossibleMoves(board, walls, stone.row, stone.col);
      if (validMoves.length === 0) continue;

      handleCellClick(stone.row, stone.col, true);
      return;
    }

  } else if (turnAction === 'wall') {
    const possibleWalls = getPossibleWalls(walls, selectedStone);
    const randomWall = possibleWalls[Math.floor(Math.random() * possibleWalls.length)];
    handleWallClick(randomWall.type, randomWall.row, randomWall.col, true);
  }
}; 
